import type { Attachment, BadgeColor } from '@billy/design-system'

import { AttachmentType } from '@features/attachments/enums/attachmentType'
import { getAttachmentEInvoiceStatus } from '@features/attachments/utils/getAttachmentEInvoiceStatus'

import { BLOCKED_E_INVOICE_STATUS_BADGE, EInvoiceStatus } from '../constants'

export interface AttachmentEInvoiceTypeBadgeConfig {
  color: BadgeColor
  labelKey: string
}

interface GetAttachmentEInvoiceTypeBadgeParams {
  attachment: Attachment
  isEInvoicingOnly?: boolean
  isShoeboxReadOnly: boolean
}

export const getAttachmentEInvoiceTypeBadge = ({
  attachment,
  isEInvoicingOnly = false,
  isShoeboxReadOnly,
}: GetAttachmentEInvoiceTypeBadgeParams): AttachmentEInvoiceTypeBadgeConfig | null => {
  const eInvoiceStatus = getAttachmentEInvoiceStatus(attachment)
  const blockedStatusBadge = eInvoiceStatus ? BLOCKED_E_INVOICE_STATUS_BADGE[eInvoiceStatus] : undefined

  if (blockedStatusBadge) {
    return blockedStatusBadge
  }

  if (attachment.file?.parentDuplicateFileId) {
    return { color: 'warning', labelKey: 'receipts.receipts_list.type.duplicate' }
  }

  if (attachment.type !== AttachmentType.EDocument) {
    return null
  }

  if (isShoeboxReadOnly) {
    if (eInvoiceStatus === EInvoiceStatus.Approved) {
      return { color: 'success', labelKey: 'receipts.receipts_list.type.approved' }
    }

    return null
  }

  return {
    color: 'accent',
    labelKey: isEInvoicingOnly ? 'receipts.filters.tab.to_review' : 'receipts.receipts_list.type.e_invoice',
  }
}
